/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export const OperatingHoursCard = defineComponent<{
  startTime: string;
  endTime: string;
  onUpdateStartTime: (value: string) => void;
  onUpdateEndTime: (value: string) => void;
}>({
  name: "OperatingHoursCard",
  props: ["startTime", "endTime", "onUpdateStartTime", "onUpdateEndTime"],
  setup(props) {
    const { t } = useLocalization();

    return () => (
      <div class="l-box-shadow rounded rounded-2xl shadow-xl bg-base-100 border border-base-100">
        <div class="card-body">
          <div class="flex items-center gap-3 mb-6">
            <div class="p-3 bg-primary/10 rounded-xl">
              <span class="material-symbols-outlined text-primary text-2xl">
                schedule
              </span>
            </div>
            <div class="flex-1">
              <h3 class="text-lg font-semibold text-accent">
                {t("settings.config.operating_hours")}
              </h3>
              <p class="text-sm text-base-content">
                {t("settings.config.operating_hours_desc")}
              </p>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="label">
                <span class="label-text font-medium">
                  {t("settings.config.opening_time")}
                </span>
              </label>
              <div class="relative">
                <input
                  type="time"
                  value={props.startTime}
                  class="input input-bordered w-full pl-12"
                  onInput={(event: Event) =>
                    props.onUpdateStartTime(
                      (event.target as HTMLInputElement).value,
                    )
                  }
                />
                <span class="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-base-content/40">
                  wb_twilight
                </span>
              </div>
              <p class="label-text-alt text-base-content/60 mt-2">
                {t("settings.config.opening_hint")}
              </p>
            </div>

            <div>
              <label class="label">
                <span class="label-text font-medium">
                  {t("settings.config.closing_time")}
                </span>
              </label>
              <div class="relative">
                <input
                  type="time"
                  value={props.endTime}
                  class="input input-bordered w-full pl-12"
                  onInput={(event: Event) =>
                    props.onUpdateEndTime(
                      (event.target as HTMLInputElement).value,
                    )
                  }
                />
                <span class="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-base-content/40">
                  nightlight
                </span>
              </div>
              <p class="label-text-alt text-base-content/60 mt-2">
                {t("settings.config.closing_hint")}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
